module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074b1_logo_200x200.cf3eaa7d.png";